import { useEffect, useRef } from "react";
import type { Strings } from "../i18n/strings";

// S2 · 헤아림 — 즉답 금지(뜸 = 무게). 달이 차오르는 동안 응답을 기다린다.
const MIN_MS = 2400;

export default function Weighing({ t, ready, onDone }: { t: Strings; ready: boolean; onDone: () => void }) {
  const startRef = useRef(Date.now());

  useEffect(() => {
    if (!ready) return;
    const elapsed = Date.now() - startRef.current;
    const id = setTimeout(onDone, Math.max(0, MIN_MS - elapsed));
    return () => clearTimeout(id);
  }, [ready, onDone]);

  return (
    <div className="screen weighing">
      <div className="weigh-moon">
        <div className="weigh-breathe" />
        <div className="weigh-full moon-disc" />
        <div className="weigh-mask" />
      </div>
      <div className="weigh-copy">
        {t.weighing.split("\n").map((line, i) => (
          <div key={i}>{line}</div>
        ))}
      </div>
    </div>
  );
}
